/* CGC in-house reviews (section cgc-reviews-inhouse). Renders every review in the product's data file exactly as stored:
   rating bars, customer photo grid, star / photo filters, sort, load more and a photo lightbox.
   Review text, ratings and counts are never edited or dropped; filters only narrow what is on screen. */
(function () {
  'use strict';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDate(d) { // "2025-03-12" -> "Mar 12, 2025" (no time zone shift)
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || '');
    return m ? MONTHS[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] : '';
  }
  function displayName(a, mode) {
    a = String(a || '').replace(/(<([^>]+)>)/ig, '');
    if (!a) return 'Customer';
    if (mode === 'full') return a;
    if (mode === 'first_initial') {
      var p = a.trim().split(/\s+/);
      return p.length > 1 ? p[0] + ' ' + p[p.length - 1].charAt(0) + '.' : p[0];
    }
    return a.substring(0, 1) + new Array(a.length).join('*'); // same as the Lai widget today (first char + stars)
  }
  function stars(r) {
    var pct = Math.max(0, Math.min(100, (r / 5) * 100));
    return '<span class="cgcr-card__stars" role="img" aria-label="' + r + ' out of 5 stars">★★★★★<i style="width:' + pct + '%">★★★★★</i></span>';
  }
  function hasMedia(r) { return (r.p && r.p.length) || (r.v && r.v.length); }
  /* r.p = card-size photos, r.pf = the same photos at lightbox size (same order; optional) */
  function photoItems(r) {
    return (r.p || []).map(function (u, i) { return { r: r, type: 'img', u: u, lu: (r.pf && r.pf[i]) || u }; });
  }

  function Reviews(root) {
    this.root = root;
    this.per = parseInt(root.getAttribute('data-per'), 10) || 10;
    this.sort = root.getAttribute('data-sort') || 'photos';
    this.names = root.getAttribute('data-names') || 'masked';
    this.serverCount = parseInt(root.getAttribute('data-count'), 10) || 0;
    this.first = parseInt(root.getAttribute('data-first'), 10) || 8;
    this.push = (root.getAttribute('data-push') || '').split(/[\s,]+/).filter(Boolean);
    this.assetBase = root.getAttribute('data-asset-base') || '';
    this.star = 0; this.photosOnly = false; this.shown = 0;
    this.$ = function (sel) { return root.querySelector(sel); };
    this.load();
  }

  Reviews.prototype.load = function () {
    var self = this, url = this.root.getAttribute('data-url'), swapUrl = this.root.getAttribute('data-swap');
    var get = function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); };
    Promise.all([get(url), swapUrl ? get(swapUrl).catch(function () { return {}; }) : Promise.resolve(null)]).then(function (res) {
      self.data = res[0];
      self.reviews = (res[0].reviews || []).slice();
      // photos given as bare file names are theme assets
      if (self.assetBase) self.reviews.forEach(function (r) {
        var abs = function (u) { return /[\/:]/.test(u) ? u : self.assetBase + u; };
        if (r.p) r.p = r.p.map(abs);
        if (r.pf) r.pf = r.pf.map(abs);
        (r.v || []).forEach(function (v) { if (v.th) v.th = abs(v.th); });
      });
      if (res[1]) self.applySwap(res[1]);
      if (self.serverCount && self.serverCount !== self.reviews.length && window.console) {
        console.warn('[cgc-reviews] summary count', self.serverCount, '!= reviews in data', self.reviews.length);
      }
      self.root.setAttribute('data-loaded', self.reviews.length);
      self.init();
    }).catch(function (e) {
      self.root.setAttribute('data-error', String(e));
      if (window.console) console.error('[cgc-reviews] could not load reviews', e);
    });
  };

  /* Setting demo_photo_swap: shows the updated rose photos on review cards. */
  Reviews.prototype.applySwap = function (map) {
    var base = this.root.getAttribute('data-swap-base') || '', n = 0;
    var swap = function (u) {
      var f = u.split('/').pop().split('?')[0];
      return map[f] ? base + map[f] : u;
    };
    this.reviews.forEach(function (r) {
      if (r.p) r.p = r.p.map(function (u) { var x = swap(u); if (x !== u) n++; return x; });
      if (r.pf) r.pf = r.pf.map(swap);
    });
    this.root.setAttribute('data-swapped', n);
  };

  /* ---------- layout "cards": one swipeable row of photo-top cards (Lai card look) ---------- */
  Reviews.prototype.lcard = function (r) {
    var name = displayName(r.a, this.names), n = +r.r || 0, hearts = '';
    for (var i = 1; i <= 5; i++) hearts += '<span' + (i <= n ? ' class="on"' : '') + '>♥</span>';
    var all = (r.p || []).map(function (u) { return { type: 'img', u: u }; })
      .concat((r.v || []).map(function (v) { return { type: 'video', u: v.u, th: v.th }; }));
    var media = '';
    if (all.length) {
      var f = all[0], src = f.type === 'img' ? f.u : f.th;
      media = '<button type="button" class="cgcr-lc__media" data-rid="' + r.id + '" data-mi="0" aria-label="Open photo from ' + esc(name) + '">' +
        (src ? '<img src="' + esc(src) + '" alt="Photo from ' + esc(name) + '" loading="lazy" decoding="async">' : '') +
        (f.type === 'video' ? '<span class="cgcr-card__play" aria-hidden="true">▶</span>' : '') +
        '<span class="cgcr-lc__n">' + all.length + ' <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><rect x="1.5" y="2.5" width="13" height="11" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M3.5 11.5l3-3.5 2.2 2.4 1.6-1.6 2.2 2.7z" fill="currentColor"/></svg></span></button>';
    }
    return '<article class="cgcr-lc' + (media ? '' : ' cgcr-lc--text') + '" role="listitem" data-review="' + r.id + '" data-rating="' + n + '">' + media +
      '<div class="cgcr-lc__hearts" role="img" aria-label="' + n + ' out of 5 stars">' + hearts + '</div>' +
      '<div class="cgcr-lc__b"><div class="cgcr-lc__who"><span class="cgcr-lc__av" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span><span>' + esc(name) + '</span></div>' +
      (r.pl ? '<p class="cgcr-lc__prod">' + esc(r.pl) + '</p>' : '') + // the product this review was written for
      (r.t ? '<p class="cgcr-lc__t">' + esc(r.t) + '</p>' : '') +
      '<p class="cgcr-lc__body">' + esc(r.b) + '</p><button type="button" class="cgcr-lc__more" hidden>Read more</button>' +
      '</div></article>'; // no date line on cards (dates stay in the data, untouched)
  };
  Reviews.prototype.initCards = function () {
    var self = this, R = this.sorted(this.sort), track = this.$('[data-cgcr-track]');
    var prev = this.$('[data-cgcr-prev]'), next = this.$('[data-cgcr-next]'), allBtn = this.$('[data-cgcr-all]');
    this.byId = {}; this.reviews.forEach(function (r) { self.byId[r.id] = r; });
    var shown = 0;
    function more() {
      var next = R.slice(shown, shown + self.first);
      track.insertAdjacentHTML('beforeend', next.map(function (r) { return self.lcard(r); }).join(''));
      shown += next.length; allBtn.hidden = shown >= R.length;
      self.root.setAttribute('data-visible', shown);
    }
    /* "Read more" only where the text is clamped */
    function clampCheck() {
      [].forEach.call(track.querySelectorAll('.cgcr-lc__body'), function (p) {
        var b = p.nextElementSibling; if (p.classList.contains('is-open')) return;
        b.hidden = p.scrollHeight <= p.clientHeight + 2;
      });
    }
    track.addEventListener('click', function (e) {
      var m = e.target.closest('.cgcr-lc__more');
      if (m) { var p = m.previousElementSibling, o = p.classList.toggle('is-open'); m.textContent = o ? 'Show less' : 'Read more'; return; }
      var b = e.target.closest('[data-rid]'); if (!b) return;
      var r = self.byId[b.getAttribute('data-rid')], list = photoItems(r);
      (r.v || []).forEach(function (v) { list.push({ r: r, type: 'video', u: v.u, th: v.th }); });
      self.openLb(list, +(b.getAttribute('data-mi') || 0));
    });
    function arrows() {
      if (self.root.classList.contains('is-all')) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function step(dir) {
      var card = track.querySelector('.cgcr-lc'), gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      var w = card ? card.offsetWidth + gap : track.clientWidth;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / w));
      track.scrollBy({ left: dir * per * w, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', function () { arrows(); clampCheck(); });
    more();
    allBtn.addEventListener('click', function () { more(); setTimeout(clampCheck, 50); });
    this.bindLb();
    clampCheck(); arrows();
  };

  Reviews.prototype.init = function () {
    if (this.root.getAttribute('data-layout') === 'cards') return this.initCards();
    var self = this, R = this.reviews, total = R.length;
    var dist = [0, 0, 0, 0, 0, 0], sum = 0;
    R.forEach(function (r) { dist[r.r] = (dist[r.r] || 0) + 1; sum += r.r; });
    this.dist = dist;
    var avg = total ? Math.round((sum / total) * 10) / 10 : 0;
    // Summary is server-rendered from the product's rating metafields; fill it only when those are missing.
    var avgEl = this.$('[data-cgcr-avg]');
    if (!avgEl.textContent.trim() && total) {
      avgEl.textContent = avg.toFixed(1);
      this.$('[data-cgcr-based]').textContent = 'Based on ' + total + (total === 1 ? ' review' : ' reviews');
    }
    // rating bars
    Array.prototype.forEach.call(this.root.querySelectorAll('.cgcr__barrow'), function (row) {
      var s = +row.getAttribute('data-star'), n = dist[s] || 0;
      row.querySelector('.cgcr__barfill').style.width = (total ? (n / total) * 100 : 0) + '%';
      row.querySelector('.cgcr__barn').textContent = n;
      row.disabled = !n;
      row.setAttribute('aria-label', s + ' stars: ' + n + ' reviews');
      row.addEventListener('click', function () { self.setStar(self.star === s ? 0 : s); });
    });
    // photo grid (every photo / video, newest first among reviews that have them)
    this.media = [];
    this.sorted('photos').forEach(function (r) {
      photoItems(r).forEach(function (m) { self.media.push(m); });
      (r.v || []).forEach(function (v) { self.media.push({ r: r, type: 'video', u: v.u, th: v.th }); });
    });
    if (this.media.length) {
      var g = this.$('[data-cgcr-gallery]'), grid = this.$('[data-cgcr-ggrid]');
      var max = window.matchMedia('(min-width:600px) and (max-width:999px)').matches ? 12 : 8;
      var show = this.media.slice(0, max);
      grid.innerHTML = show.map(function (m, i) {
        var more = (i === show.length - 1 && self.media.length > max) ? '<span class="cgcr__gmore">+' + (self.media.length - max + 1) + '</span>' : '';
        var src = m.type === 'img' ? m.u : (m.th || '');
        return '<button type="button" class="cgcr__gthumb" data-gi="' + i + '" aria-label="Open customer photo ' + (i + 1) + '">' +
          (src ? '<img src="' + esc(src) + '" alt="Customer photo" loading="lazy" decoding="async">' : '') + more + '</button>';
      }).join('');
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-gi]'); if (b) self.openLb(self.media, +b.getAttribute('data-gi'));
      });
      this.$('[data-cgcr-gcount]').textContent = '(' + this.media.length + ')';
      g.hidden = false;
    }
    // chips
    var photoN = R.filter(hasMedia).length;
    var chips = '<button type="button" class="cgcr__chip is-on" data-chip="all"><b>All</b><span>' + total + '</span></button>';
    for (var s = 5; s >= 1; s--) {
      chips += '<button type="button" class="cgcr__chip" data-chip="' + s + '"' + (dist[s] ? '' : ' disabled') + '><b>' + s + '</b><span class="cgcr__cs">★</span><span>' + dist[s] + '</span></button>';
    }
    chips += '<button type="button" class="cgcr__chip" data-chip="photos"' + (photoN ? '' : ' disabled') + '><b>With photos</b><span>' + photoN + '</span></button>';
    var cw = this.$('[data-cgcr-chips]'); cw.innerHTML = chips;
    cw.addEventListener('click', function (e) {
      var b = e.target.closest('[data-chip]'); if (!b || b.disabled) return;
      var v = b.getAttribute('data-chip');
      if (v === 'all') { self.star = 0; self.photosOnly = false; }
      else if (v === 'photos') { self.photosOnly = !self.photosOnly; }
      else { self.star = self.star === +v ? 0 : +v; }
      self.render(true);
    });
    var sel = this.$('[data-cgcr-sort]'); sel.value = this.sort;
    sel.addEventListener('change', function () { self.sort = sel.value; self.render(true); });
    this.$('[data-cgcr-more]').addEventListener('click', function () { self.render(false); });
    this.$('[data-cgcr-list]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-rid]'); if (!b) return;
      var r = self.byId[b.getAttribute('data-rid')], list = photoItems(r);
      (r.v || []).forEach(function (v) { list.push({ r: r, type: 'video', u: v.u, th: v.th }); });
      self.openLb(list, +(b.getAttribute('data-mi') || 0));
    });
    this.byId = {}; R.forEach(function (r) { self.byId[r.id] = r; });
    this.bindLb();
    this.render(true);
  };

  Reviews.prototype.setStar = function (s) { this.star = s; this.render(true); };

  Reviews.prototype.sorted = function (mode) {
    var key = function (r) { return r.d || ''; };
    var byNew = function (a, b) { return key(b) < key(a) ? -1 : key(b) > key(a) ? 1 : b.id - a.id; };
    var R = this.reviews.slice();
    if (mode === 'listed') return R; // keep the data file's order
    if (mode === 'newest') R.sort(byNew);
    else if (mode === 'highest') R.sort(function (a, b) { return b.r - a.r || byNew(a, b); });
    else if (mode === 'lowest') R.sort(function (a, b) { return a.r - b.r || byNew(a, b); });
    else {
      var push = this.push || [], pd = function (r) { return push.indexOf(String(r.id)) > -1 ? 1 : 0; };
      // photos first; reviews in the section's "push down" list go to the END of the photo reviews (reordered, never dropped)
      R.sort(function (a, b) { return (hasMedia(b) ? 1 : 0) - (hasMedia(a) ? 1 : 0) || pd(a) - pd(b) || byNew(a, b); });
    }
    return R;
  };

  Reviews.prototype.filtered = function () {
    var self = this;
    return this.sorted(this.sort).filter(function (r) {
      return (!self.star || r.r === self.star) && (!self.photosOnly || hasMedia(r));
    });
  };

  Reviews.prototype.card = function (r) {
    var media = '', thumbs = '', name = displayName(r.a, this.names);
    var all = (r.p || []).map(function (u) { return { type: 'img', u: u }; })
      .concat((r.v || []).map(function (v) { return { type: 'video', u: v.u, th: v.th }; }));
    if (all.length) {
      var f = all[0], fsrc = f.type === 'img' ? f.u : f.th;
      media = '<button type="button" class="cgcr-card__media" data-rid="' + r.id + '" data-mi="0" aria-label="Open photo from ' + esc(name) + '">' +
        (fsrc ? '<img src="' + esc(fsrc) + '" alt="Photo from ' + esc(name) + '" loading="lazy" decoding="async">' : '') +
        (f.type === 'video' ? '<span class="cgcr-card__play" aria-hidden="true">▶</span>' : '') +
        (all.length > 1 ? '<span class="cgcr-card__mcount">' + all.length + ' photos</span>' : '') + '</button>';
      if (all.length > 1) {
        thumbs = '<div class="cgcr-card__thumbs">' + all.slice(1).map(function (m, i) {
          var s = m.type === 'img' ? m.u : m.th;
          return '<button type="button" data-rid="' + r.id + '" data-mi="' + (i + 1) + '" aria-label="Open photo ' + (i + 2) + '">' + (s ? '<img src="' + esc(s) + '" alt="" loading="lazy" decoding="async">' : '▶') + '</button>';
        }).join('') + '</div>';
      }
    }
    var replies = (r.rp || []).map(function (x) {
      return '<div class="cgcr-card__reply"><b>' + esc(x.f || 'Corazon Gift Co.') + ' replied</b>' + esc(x.c) + '</div>';
    }).join('');
    return '<article class="cgcr-card" data-review="' + r.id + '" data-rating="' + r.r + '">' + media +
      '<div class="cgcr-card__b"><div class="cgcr-card__row">' + stars(r.r) + '</div>' +
      '<div class="cgcr-card__who"><span class="cgcr-card__av" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span><span class="cgcr-card__name">' + esc(name) + '</span>' +
      (r.vf ? '<span class="cgcr-card__vf">Verified buyer</span>' : '') + '</div>' +
      (r.t ? '<p class="cgcr-card__t">' + esc(r.t) + '</p>' : '') +
      '<p class="cgcr-card__body">' + esc(r.b) + '</p>' + thumbs + replies + '</div></article>';
  };

  Reviews.prototype.render = function (reset) {
    var self = this, list = this.$('[data-cgcr-list]'), F = this.filtered();
    if (reset) { this.shown = 0; list.innerHTML = ''; }
    var next = F.slice(this.shown, this.shown + this.per);
    list.insertAdjacentHTML('beforeend', next.map(function (r) { return self.card(r); }).join(''));
    this.shown += next.length;
    this.$('[data-cgcr-empty]').hidden = F.length > 0;
    this.$('[data-cgcr-more]').hidden = this.shown >= F.length;
    this.$('[data-cgcr-shown]').textContent = ''; // never show "Showing X of Y"
    // chip + bar state
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-chip]'), function (b) {
      var v = b.getAttribute('data-chip');
      b.classList.toggle('is-on', v === 'all' ? (!self.star && !self.photosOnly) : v === 'photos' ? self.photosOnly : +v === self.star);
      b.setAttribute('aria-pressed', b.classList.contains('is-on'));
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('.cgcr__barrow'), function (b) {
      b.classList.toggle('is-on', +b.getAttribute('data-star') === self.star);
    });
    this.root.setAttribute('data-visible', this.shown);
    this.root.setAttribute('data-filtered', F.length);
  };

  /* lightbox */
  Reviews.prototype.bindLb = function () {
    var self = this, lb = this.$('[data-cgcr-lb]');
    document.body.appendChild(lb); // escape any transformed / overflow-hidden ancestor
    this.lb = lb;
    lb.querySelector('[data-cgcr-lbclose]').addEventListener('click', function () { self.closeLb(); });
    lb.querySelector('[data-cgcr-lbprev]').addEventListener('click', function () { self.stepLb(-1); });
    lb.querySelector('[data-cgcr-lbnext]').addEventListener('click', function () { self.stepLb(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) self.closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') self.closeLb();
      if (e.key === 'ArrowLeft') self.stepLb(-1);
      if (e.key === 'ArrowRight') self.stepLb(1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) self.stepLb(dx < 0 ? 1 : -1);
    });
  };
  Reviews.prototype.openLb = function (list, i) {
    this.lbList = list; this.lbI = i; this.lb.hidden = false;
    document.documentElement.classList.add('cgcr-lock');
    this.drawLb(); this.lb.querySelector('[data-cgcr-lbclose]').focus();
  };
  Reviews.prototype.closeLb = function () {
    this.lb.hidden = true; document.documentElement.classList.remove('cgcr-lock');
    this.lb.querySelector('[data-cgcr-lbmedia]').innerHTML = '';
  };
  Reviews.prototype.stepLb = function (d) {
    var n = this.lbList.length; if (n < 2) return;
    this.lbI = (this.lbI + d + n) % n; this.drawLb();
  };
  Reviews.prototype.drawLb = function () {
    var m = this.lbList[this.lbI], r = m.r || this.byId[m.rid], name = displayName(r.a, this.names);
    this.lb.querySelector('[data-cgcr-lbmedia]').innerHTML = m.type === 'video'
      ? '<video src="' + esc(m.u) + '" ' + (m.th ? 'poster="' + esc(m.th) + '" ' : '') + 'controls playsinline autoplay muted></video>'
      : '<img src="' + esc(m.lu || m.u) + '" alt="Photo from ' + esc(name) + '">';
    this.lb.querySelector('[data-cgcr-lbinfo]').innerHTML =
      '<div class="cgcr-card__row">' + stars(r.r) + '</div>' +
      '<div class="cgcr-card__who"><span class="cgcr-card__av" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span>' + esc(name) + '</div>' +
      (r.pl ? '<p class="cgcr-lc__prod">' + esc(r.pl) + '</p>' : '') +
      (r.t ? '<p class="cgcr-card__t">' + esc(r.t) + '</p>' : '') + '<p class="cgcr-card__body">' + esc(r.b) + '</p>' +
      (this.lbList.length > 1 ? '<div class="cgcr-lb__count">' + (this.lbI + 1) + ' / ' + this.lbList.length + '</div>' : '');
    var many = this.lbList.length > 1;
    this.lb.querySelector('[data-cgcr-lbprev]').hidden = !many;
    this.lb.querySelector('[data-cgcr-lbnext]').hidden = !many;
  };

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cgcr]:not([data-cgcr-init])'), function (el) {
      el.setAttribute('data-cgcr-init', '1'); new Reviews(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
